if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        this.productInfo = document.getElementById(
          `ProductInfo-${this.dataset.section}`
        );

        this.prependMedia = this.dataset.disablePrepend !== 'true';
        this.filteringOption = this.dataset.filteringOption;

        if (this.productInfo && Shopify.postLinksRetry) {
          this.productInfo.initShareLinks();
        }

        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');

              if (button) {
                button.addEventListener(
                  'click',
                  this.setActiveMedia.bind(
                    this,
                    mediaToSwitch.dataset.target,
                    false
                  )
                );
              }
            });
        }

        if (
          this.elements.thumbnails &&
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }

        /*
         * VARIANT CHANGE
         *
         * Shrine handles the variant itself.
         * We only wait until Shrine has finished changing
         * the variant and then update the gallery.
         */
        /*
 * VARIANT CHANGE
 *
 * Listen to Shrine's own variantChange event.
 * Shrine fires this AFTER the product section has
 * been updated, so we always work with the current gallery.
 */

if (
  typeof subscribe === 'function' &&
  typeof PUB_SUB_EVENTS !== 'undefined' &&
  !window.__minisaunaGalleryVariantListener
) {
  window.__minisaunaGalleryVariantListener = subscribe(
    PUB_SUB_EVENTS.variantChange,
    (event) => {
      if (!event || !event.data || !event.data.variant) return;

      const variant = event.data.variant;

      const galleries = document.querySelectorAll(
        'media-gallery[data-filtering-option]'
      );

      galleries.forEach((gallery) => {
        if (
          event.data.sectionId &&
          event.data.sectionId !== gallery.dataset.section
        ) {
          return;
        }

        let optionIndex = 0;

        if (gallery.dataset.filteringOption === 'option2') {
          optionIndex = 1;
        } else if (gallery.dataset.filteringOption === 'option3') {
          optionIndex = 2;
        }

        const selectedValue = variant.options?.[optionIndex];

        if (!selectedValue) return;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            gallery.applyVariantGallery(selectedValue);
          });
        });
      });
    }
  );
}
  
}
      

      /*
       * Read the currently selected Capacity and
       * filter the gallery accordingly.
       */
      applyVariantGallery(selectedValue) {
  if (!this.filteringOption) return;

  if (!selectedValue) return;
const selectedNormalized = this.normalizeValue(selectedValue);

if (!selectedNormalized) return;

let wanted = selectedNormalized;

if (
  selectedNormalized.includes('for one') ||
  selectedNormalized.includes('för en') ||
  selectedNormalized.includes('yhdelle') ||
  selectedNormalized.includes('ühele')
) {
  wanted = this.normalizeValue('Minisauna "For One"');
} else if (
  selectedNormalized.includes('for two') ||
  selectedNormalized.includes('för två') ||
  selectedNormalized.includes('kahdelle') ||
  selectedNormalized.includes('kahele')
) {
  wanted = this.normalizeValue('Minisauna "For Two"');
} else if (
  selectedNormalized.includes('for three') ||
  selectedNormalized.includes('för tre') ||
  selectedNormalized.includes('kolmelle') ||
  selectedNormalized.includes('kolmele')
) {
  wanted = this.normalizeValue('Minisauna "For Two"');
}

        /*
         * 1. HIDE / SHOW MAIN SLIDES
         */
        this.querySelectorAll('.product__media-item').forEach((slide) => {
          const alt = this.normalizeValue(slide.dataset.alt);

          const visible =
            alt === wanted ||
            alt === 'always_display';

          slide.classList.toggle('hidden', !visible);
          slide.classList.toggle('is-active', false);
        });

        /*
         * 2. HIDE / SHOW THUMBNAILS
         */
        this.querySelectorAll('.thumbnail-list__item').forEach((thumb) => {
          const alt = this.normalizeValue(thumb.dataset.alt);

          const visible =
            alt === wanted ||
            alt === 'always_display';

          thumb.classList.toggle('hidden', !visible);
        });

        /*
         * 3. HIDE / SHOW DOTS
         */
        this.querySelectorAll('.slider-counter__link').forEach((dot) => {
          const alt = this.normalizeValue(dot.dataset.alt);

          const visible =
            alt === wanted ||
            alt === 'always_display';

          dot.classList.toggle('hidden', !visible);
        });

        /*
         * VERY IMPORTANT:
         * Wait until the browser has actually applied
         * display:none to the old slides.
         */
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.moveToFirstVisibleSlide();
          });
        });
      }

      /*
       * Convert all language versions of the variant
       * into the same gallery value.
       */
      normalizeValue(value) {
        if (!value) return '';

        const v = String(value)
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

        if (
          v.includes('for one') ||
          v.includes('for en') ||
          v.includes('yhdelle') ||
          v.includes('uhele') ||
          v.includes('one')
        ) {
          return 'minisauna "for one"';
        }

        /*
         * FOR TWO AND FOR THREE USE THE SAME GALLERY.
         */
        if (
          v.includes('for two') ||
          v.includes('for three') ||
          v.includes('for tva') ||
          v.includes('for tre') ||
          v.includes('kahdelle') ||
          v.includes('kolmelle') ||
          v.includes('kahele') ||
          v.includes('kolmele') ||
          v.includes('two') ||
          v.includes('three')
        ) {
          return 'minisauna "for two"';
        }

        if (v === 'always_display') {
          return 'always_display';
        }

        return v;
      }

      /*
       * THIS IS THE IMPORTANT PART.
       *
       * After filtering, Shrine's slider still remembers
       * the old scroll position.
       *
       * We rebuild its pages and explicitly move it to
       * the FIRST currently visible slide.
       */
      moveToFirstVisibleSlide() {
        const viewer = this.elements.viewer;

        if (!viewer) return;

        const slider = viewer.slider;

        if (!slider) return;

        /*
         * Find the first slide that is NOT hidden.
         */
        const visibleSlides = Array.from(
          viewer.querySelectorAll('.product__media-item')
        ).filter((slide) => {
          return !slide.classList.contains('hidden');
        });

        if (!visibleSlides.length) return;

        const firstSlide = visibleSlides[0];

        /*
         * Remove active state from every slide.
         */
        viewer
          .querySelectorAll('.product__media-item')
          .forEach((slide) => {
            slide.classList.remove('is-active');
          });

        /*
         * Make the new first slide active.
         */
        firstSlide.classList.add('is-active');

        /*
         * Rebuild Shrine's internal slider calculations.
         *
         * This is important because hidden slides have now
         * disappeared from the layout.
         */
        if (typeof viewer.resetPages === 'function') {
          viewer.resetPages();
        }

        /*
         * NOW FORCE THE ACTUAL SLIDER TO THE BEGINNING.
         *
         * Do NOT use firstSlide.offsetLeft here.
         * Hidden slides and Shrine's scroll multiplier can
         * otherwise leave the slider at the previous position.
         */
        requestAnimationFrame(() => {
          if (viewer.vertical) {
            slider.scrollTo({
              top: 0,
              behavior: 'auto'
            });
          } else {
            slider.scrollTo({
              left: 0,
              behavior: 'auto'
            });
          }

          /*
           * Update Shrine's currentPage/currentElement.
           */
          if (typeof viewer.update === 'function') {
            viewer.update();
          }
        });

        /*
         * Update thumbnail selection.
         */
        if (this.elements.thumbnails) {
          const mediaId = firstSlide.dataset.mediaId;

          if (mediaId) {
            const thumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (thumbnail) {
              this.setActiveThumbnail(thumbnail);
            }
          }
        }

        /*
         * Play the new active media if necessary.
         */
        this.playActiveMedia(firstSlide);
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const currentElement =
          event.detail && event.detail.currentElement;

        if (!currentElement) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${currentElement.dataset.mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const viewer = this.elements.viewer;

        if (!viewer) return;

        const activeMedia = viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        if (activeMedia.classList.contains('hidden')) return;

        viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend && this.prependMedia) {
          activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (viewer.slider && typeof viewer.resetPages === 'function') {
            viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        if (viewer.slider) {
          const slider = viewer.slider;

          requestAnimationFrame(() => {
            if (viewer.vertical) {
              slider.scrollTo({
                top: activeMedia.offsetTop,
                behavior: 'auto'
              });
            } else {
              slider.scrollTo({
                left:
                  activeMedia.offsetLeft *
                  (typeof viewer.scrollMultiplier === 'number'
                    ? viewer.scrollMultiplier
                    : 1),
                behavior: 'auto'
              });
            }

            if (typeof viewer.update === 'function') {
              viewer.update();
            }
          });
        }

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        const button = thumbnail.querySelector('button');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (
          typeof this.elements.thumbnails.isSlideVisible === 'function' &&
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            false,
            10,
            true
          )
        ) {
          return;
        }

        if (this.elements.thumbnails.vertical) {
          this.elements.thumbnails.slider.scrollTo({
            top: thumbnail.offsetTop,
            behavior: 'auto'
          });
        } else {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
            behavior: 'auto'
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;

        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }

      disconnectedCallback() {
  clearTimeout(this.variantChangeTimeout);
}

      }
    
  );
}